export const MOVENEXT_TYPES = {
  MOVENEXT_TYPE_STANDARD: 1,
  MOVENEXT_TYPE_NOBACK: 2,
  MOVENEXT_TYPE_AUTOMATIC: 3
}
